export default __webpack_public_path__ + "static/media/launch-grow.71051c5f.png";